























import Vue from 'vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'

interface ComponentData {
  dateFormatted: string
  date: string
  dateRules: Array<(v: string) => string | boolean>
  menu: boolean
}

interface Payload {
  name: string
  value: string
  label: string
}

export default Vue.extend({
  name: 'ReportingDatePicker',

  props: {
    name: String,
    label: String,
    defaulValue: String,
    isRequired: Boolean,
    isValid: Boolean
  },

  data (): ComponentData {
    return {
      dateFormatted: '',
      date: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value && value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          if (this.isRequired) {
            return !!value || this.$t('reportingFilter.valueIsRequired').toString()
          } else {
            return true
          }
        }
      ],
      menu: false
    }
  },

  computed: {
    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  watch: {
    isValid (newVal: boolean): void {
      if (newVal === true) {
        const form: any = this.$refs['form']
        if (form.validate()) {}
      }
    },

    dateFormatted (newVal: string): void {
      if(newVal.length > 0) {
        this.date = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
        const form: any = this.$refs['form']
        if(newVal.length === 10 && form.validate()) {
          this.onValueChange()
        } else if(newVal.length !== 10) {
          this.date = ''
          this.onValueChange()
        }
      } else {
        this.date = ''
        this.onValueChange()
      }
    }
  },

  methods: {
    onDateChange (date: string): void {
      if(date.length > 0) {
        this.dateFormatted = moment(date).format('DD.MM.YYYY')
        this.onValueChange()
      } else {
        this.dateFormatted = ''
        this.onValueChange()
      }
    },

    onValueChange (): void {
        let payload: Payload = { name: this.name, value: this.date, label: this.date }
        this.$emit('dateChange', payload)
    }
  },

  created () {
    if (this.defaulValue) {
      this.date = this.defaulValue
    }
    if (this.date) {
      let payload: Payload = { name: this.name, value: this.date, label: this.date }
      this.$emit('dateChange', payload)
    }
  }

})
